// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"b938e32f","669":"b938e32f","753":"b938e32f","807":"259c65f8"}[chunkId] + ".chunk.css";
};